import { APPLICATION_URL } from "../../content";
import { Button } from "../ui/Button";
import { AutterWordmark } from "../brand/AutterBrand";
import { Compass } from "@phosphor-icons/react";

export function Nav({ onPlay }: { onPlay: () => void }) {
  return (
    <header className="fixed inset-x-0 top-0 z-50 h-[4.5rem] border-b border-line/60 bg-paper/92 backdrop-blur-xl">
      <div className="mx-auto flex h-full w-full max-w-[1400px] items-center justify-between gap-4 px-5 md:px-10">
        <a href="#top" className="flex min-w-0 items-center gap-3" aria-label="Autter Same Boat, back to top">
          <AutterWordmark className="h-6 w-auto shrink-0 md:h-7" />
          <span className="hidden h-5 w-px bg-line sm:block" aria-hidden />
          <span className="hidden font-mono text-[10px] tracking-[0.16em] text-ink uppercase sm:block">Same Boat</span>
        </a>

        <nav aria-label="Story chapters" className="hidden items-center gap-1 rounded-full border border-line bg-foam p-1 lg:flex">
          <a href="#story" className="rounded-full px-4 py-2 text-xs font-semibold text-muted transition-colors hover:bg-paper-deep hover:text-ink">The story</a>
          <a href="#boats" className="rounded-full px-4 py-2 text-xs font-semibold text-muted transition-colors hover:bg-paper-deep hover:text-ink">Find your boat</a>
        </nav>

        <div className="flex items-center gap-3">
          <span className="hidden font-mono text-[9px] tracking-[0.12em] text-muted uppercase md:block">A community voyage</span>
          <button
            type="button"
            onClick={onPlay}
            className="inline-flex min-h-10 items-center gap-2 rounded-full border border-ink px-3.5 text-xs font-semibold text-ink transition-colors hover:bg-ink hover:text-foam"
          >
            <Compass className="size-4" weight="bold" aria-hidden />
            <span className="hidden sm:inline">Play</span>
          </button>
          <Button href={APPLICATION_URL} size="sm">Apply</Button>
        </div>
      </div>
    </header>
  );
}
